var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.999 9.217l4.773-1.597m-6.283 6.398l2.817 3.942m-7.824-3.942L4.548 17.82m1.527-8.603L1.38 7.62m8.615-1.341V1.504"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.824 1.854a2 2 0 0 1 2.351 0L17.86 6.71a2 2 0 0 1 .726 2.236l-2.553 7.857a2 2 0 0 1-1.902 1.382H5.869a2 2 0 0 1-1.902-1.382L1.414 8.946a2 2 0 0 1 .727-2.236l6.684-4.856z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.853 5.728a.25.25 0 0 1 .294 0l4.346 3.157a.25.25 0 0 1 .091.28l-1.66 5.109a.25.25 0 0 1-.238.173H7.314a.25.25 0 0 1-.238-.173l-1.66-5.109a.25.25 0 0 1 .091-.28l4.346-3.157z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.31a80bda.svg";
export { ForwardRef as ReactComponent };